import { ethers } from "ethers";
// eslint-disable-next-line import/prefer-default-export
export function getAddress(address) {
    return ethers.getAddress(address);
}
//# sourceMappingURL=address.js.map